import { Project } from '~/types/project';

export const autopricingConditions = (project: Project) => {
  const key = project?.pricingType === 'DEV_FEE' ? 'ACQUISITION' : project?.pricingType;
  const hasPricingEstimate = Boolean(project.autopricingResult?.[key]?.length);
  return { hasPricingEstimate };
};